import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	fetchUser
} from '../../../actions';

import Button from '@material-ui/core/Button';
import ForwardICon from '@material-ui/icons/Forward';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import PropTypes from "prop-types";


const styles = theme => ({
	singInButton: {
		marginRight: theme.spacing.unit,
	},
	textField:{
		width:'100%',
		marginBottom:15
	},
	resetFormText:{
		color:'#40bad0',
		cursor:'pointer'
	}
});


class login extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			inputData : {
				auto_login: true,
				jigyousha_cd : '',
				user_id : '',
				password : ''
			},
			error : null,
			showPassword : false
		}
	}

	_handleClickShowPassword(){
		this.setState({ showPassword: !this.state.showPassword });
	}


	_onClickSubmit(){
		const {dispatch} = this.props;
		const data = this.state.inputData;
		const jigyousha_cd = String(data.jigyousha_cd).trim();
		const user_id = String(data.user_id).trim();
		const password = String(data.password).trim();
		const auto_login = data.auto_login;
		if(!jigyousha_cd || !user_id || !password){
			this.setState({
				error : '事業者コード/ユーザーID/パスワードを入力してください'
			});
		}
		else{
			dispatch(fetchUser({
				jigyousha_cd,
				user_id,
				password,
				auto_login,
				SessionID : this.getRandomString()
			}));
		}
	}

	_handleChange(event) {
		let inputData = this.state.inputData;
		switch (event.target.name) {
			case 'jigyousha_cd':
				inputData.jigyousha_cd = event.target.value;
				break;
			case 'user_id':
				inputData.user_id = event.target.value;
				break;
			case 'password':
				inputData.password = event.target.value;
				break;
			case 'auto_login':
				inputData.auto_login = !inputData.auto_login;
				break;
			default:
				break;
		}
		this.setState({
			inputData
		});
	}

	_handleKeyPress(event){
		if(event.key !== 'Enter'){
			return
		}
		const inputData = this.state.inputData;
		let jigyousha_cd = inputData.jigyousha_cd;
		let user_id = inputData.user_id;
		let password = inputData.password;
		switch (event.target.name) {
			case 'jigyousha_cd':
				this.user_id.focus();
				break;
			case 'user_id':
				this.password.focus();
				break;
			case 'password':
				if(jigyousha_cd && user_id && password){
					this._onClickSubmit();
				}
				else{
					this.jigyousha_cd.focus();
				}
				break;
			default:
				break;
		}
	}

	getRandomString = () =>{
		const l = 20;
		// 生成する文字列に含める文字セット
		const c = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		const cl = c.length;
		let r = "";
		for(let i=0; i<l; i++){
			r += c[Math.floor(Math.random()*cl)];
		}
		return r;
	};

	handleOpenResetForm = () =>{
		const {jigyousha_cd,user_id} = this.state.inputData;
		if(this.props.openResetFormFunc) this.props.openResetFormFunc(jigyousha_cd,user_id);
	}

	render () {
		const { classes } = this.props;
		const auth = this.props.auth;
		const error = (auth.error) ? auth.error : this.state.error;
		return (
			<div id="login_area">
				<div className="login_main_box">
					<h2><i className="material-icons">
						lock_open
					</i>ログイン</h2>
					<TextField
						label="事業者コード"
						placeholder="事業者コード"
						className={classes.textField}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						name="jigyousha_cd"
						autoFocus={true}
						inputRef={field => this.jigyousha_cd = field}
						inputProps={{
							maxLength:10
						}}
					/>
					<TextField
						label="ユーザーID"
						placeholder="ユーザーID"
						className={classes.textField}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						name="user_id"
						inputRef={field => this.user_id = field}
						inputProps={{
							maxLength:20
						}}
					/>
					<TextField
						label="パスワード"
						placeholder="パスワード"
						className={classes.textField}
						type={this.state.showPassword ? 'text' : 'password'}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						InputProps={{
						endAdornment:(
							<InputAdornment position="end">
								<IconButton
									aria-label="Toggle password visibility"
									onClick={this._handleClickShowPassword.bind(this)}
								>
									{this.state.showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>
						)
						}}
						inputProps={{
							maxLength:20
						}}
						name="password"
						inputRef={field => this.password = field}
					/>


					<div className="btn_area clearfix">
						<FormControlLabel
							control={
								<Checkbox
									checked={this.state.inputData.auto_login}
									onChange={this._handleChange.bind(this)}
									value="checkedB"
									color="primary"
									name="auto_login"
								/>
							}
							label="次回から自動でログイン"
							className="fl_left"
						/>
						<Button variant="contained" color="primary" className="fl_right" onClick={this._onClickSubmit.bind(this)}>
							<ForwardICon className={classes.singInButton} />
							ログイン
						</Button>
					</div>

					{error &&
					<div className="caution_area">
						<i className="fa fa-exclamation-triangle" aria-hidden="true" />
						<p>{error}</p>
					</div>
					}
					<p className="copyright fsm5 ta_center">TSUNAGUTE</p>
				</div>
			</div>
		);
	}
}
login.propTypes = {
	openResetFormFunc:PropTypes.func

};
function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(login);



// WEBPACK FOOTER //
// ./src/routes/menu/components/login.js